import axios from 'axios';
import qs from 'qs';
const isProduction = process.env.NODE_ENV === 'production';
import Cookies from 'cookies-js';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: true,
  timeout: 10 * 60 * 1000,
  adapter: retryAdapterEnhancer(axios.defaults.adapter, {
    retryDelay: 1000,
  }),
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

// 请求拦截器
service.interceptors.request.use((_) => {
  const config = _;
  //do something before request is send
  const IS_GET = config.method === 'get';
  const data = (IS_GET ? config.params : config.data) || {};
  const token = isProduction ? Cookies.get('token1') : localStorage.getItem('token');
  if (!isProduction && token) {
    config.headers['Authorization'] = token;
  }
  //
  if (config.url.indexOf('/community/') > -1) {
    config.baseURL = process.env.VUE_APP_COMMUNITY_RUL;
  }
  if (IS_GET) {
    config.params = data;
  } else {
    if (['application/json', 'multipart/form-data'].includes(config.headers['Content-Type'])) {
      config.data = data;
    } else {
      config.data = qs.stringify(data);
    }
  }

  return {
    ...config,
  };
});

//响应拦截;
service.interceptors.response.use(
  (response) => {
    const config = response.config;
    if (config && config.responseType == 'blob') {
      // 处理content-disposition
      const contentDisposition = response.headers['content-disposition'];
      const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*');
      const result = patt.exec(contentDisposition);
      console.log(config.filename);
      const repFilename = result && result[1] ? decodeURI(result[1]) : config.filename;
      const filename = qs.parse(config)?.filename || repFilename || '';
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
      });
      // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型

      if ('download' in document.createElement('a')) {
        const downloadElement = document.createElement('a');
        let href = '';
        if (window.URL) href = window.URL.createObjectURL(blob);
        else href = window.webkitURL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = filename;
        // downloadElement.href = xss.escapeAttrValue(href);
        // downloadElement.download = xss.escapeAttrValue(filename);
        document.body?.appendChild(downloadElement);
        downloadElement.click();
        if (window.URL) window.URL.revokeObjectURL(href);
        else window.webkitURL.revokeObjectURL(href);
        downloadElement.href = '';
        downloadElement.download = '';
        document.body?.removeChild(downloadElement);
      } else {
        navigator.msSaveBlob(blob, filename);
      }
      return;
    }
    return response.data.code == 200 || response.data.success
      ? Promise.resolve(response.data)
      : Promise.reject({ ...response.data, message: response?.data?.msg || '网络错误' });
  },
  (error) => {
    if (error && error.response) {
      console.log(error.response.statusText);
    }
    const data = error?.response?.data || {};
    if (error.response?.status == 401) {
      data.message = '还没有登录哦，请登录后完成此操作';
      data.code = 401;
    }
    return Promise.reject({
      ...data,
      message: data.message || data.error || error.message || '网络错误 请稍后再试',
    });
  },
);

// 失败重试
function retryAdapterEnhancer(adapter, options) {
  const { times = 0, delay = 300 } = options;
  return async (config) => {
    const { retryTimes = times, retryDelay = delay } = config;
    let __retryCount = 0;
    const request = async () => {
      try {
        return await adapter(config);
      } catch (err) {
        if (!retryTimes || __retryCount >= retryTimes) {
          return Promise.reject(err);
        }
        __retryCount += 1;
        // 延时处理
        const delay = new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, retryDelay);
        });
        // 重新发起请求
        return delay.then(() => {
          return request();
        });
      }
    };
    return request();
  };
}

export default service;
